import img18a from '../../../assets/gallery/18c/18c-01-HOME_barro.jpg';
import img18b from '../../../assets/gallery/18c/18c-02_barro.jpg';
import img18c from '../../../assets/gallery/18c/18c-03_barro.jpg';
import img18d from '../../../assets/gallery/18c/18c-04_barro.jpg';
import img18e from '../../../assets/gallery/18c/18c-05_ST-2018-300x400cm-oleo-sobre-madera.jpg';
import img18f from '../../../assets/gallery/18c/18c-06-HOME_ST-2018-200x300cm-oleo-sobre-madera.jpg';
import img18g from '../../../assets/gallery/18c/18c-07_ST-2018-244x244cm-oleo-sobre-madera.jpg';
import img18h from '../../../assets/gallery/18c/18c-08_ST-2018-244x366cm-oleo-sobre-madera.jpg';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "",
    pictureSrc: img18a,
    description: "2018",
    orientation: "h"
  },
  {
    id: 2,
    title: "",
    dimensions: "",
    pictureSrc: img18b,
    description: "2018",
    orientation: "h"
  },
  {
    id: 3,
    title: "",
    dimensions: "",
    pictureSrc: img18c,
    description: "2018",
    orientation: "h"
  },
  {
    id: 4,
    title: "",
    dimensions: "",
    pictureSrc: img18d,
    description: "2018",
    orientation: "h"
  },
  {
    id: 5,
    title: "",
    dimensions: "300 x 400 cm",
    pictureSrc: img18e,
    description: "2018",
    orientation: "h"
  },
  {
    id: 6,
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img18f,
    description: "2018",
    orientation: "h"
  },
  {
    id: 7,
    title: "",
    dimensions: "244 x 244 cm",
    pictureSrc: img18g,
    description: "2018",
    orientation: "h"
  },
  {
    id: 8,
    title: "",
    dimensions: "244 x 366 cm",
    pictureSrc: img18h,
    description: "2018",
    orientation: "h"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


// WEBPACK FOOTER //
// ./src/pages/gallery/18c/data18c.js